import React from "react";
import PortfolioConfigData from "config/portfolio-config.json";
import styles from "./portfolioCompareTableBar.module.scss";
import { useTranslation } from "react-i18next";

const FinecoTableCompare = ({ dataObject, dataObject2 }) => {
  const { t } = useTranslation();

  if (!dataObject.data || !dataObject2?.data) {
    return null;
  }

  const total1 = Math.round(
    dataObject.data.reduce((sum, row) => sum + row.weight, 0),
  );

  const total2 = Math.round(
    dataObject2.data.reduce((sum, row) => sum + row.weight, 0),
  );

  const paletteArray =
    PortfolioConfigData.palettes[dataObject.configData.palette];

  return (
    <div className={styles.tableContainer}>
      {/* Positioned Peso label */}
      <div className={styles.pesoCellHeader}>
        <span>{dataObject.configData.label_table_right}</span>
      </div>

      <table className={styles.distributionTable}>
        <thead>
          <tr>
            <th>{dataObject.configData.label_table_left}</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td>
              <span className={styles.portafolio}>
                {t("portafoglioCompare.portafoglio1")}
              </span>
            </td>
            <td>
              <span className={styles.portafolio}>
                {t("portafoglioCompare.portafoglio2")}
              </span>
            </td>
          </tr>
          {dataObject.data.map((row, index) => {
            const colorIndex = index % paletteArray.length;
            const displayLabel = dataObject.configData.rows
              ? dataObject.configData.rows[row.label] || row.label
              : row.label;

            // Find the corresponding row in dataObject2
            const row2 = dataObject2.data.find(
              (r) => r.label === row.label,
            ) || { weight: 0 };

            return (
              <tr key={index}>
                <td>
                  <div className={styles.tableSimpleTdContainer}>
                    <div className={styles.tableSimpleTd}>
                      <span className={styles.tableValues}>{displayLabel}</span>
                    </div>
                  </div>
                </td>
                <td className={styles.tableLine}>
                  <span className={styles.tableValues}>
                    {row.weight.toFixed(2)}
                  </span>
                </td>
                <td className={styles.tableNoLine}>
                  <span className={styles.tableValues2}>
                    {row2.weight.toFixed(2)}
                  </span>
                </td>
              </tr>
            );
          })}
          <tr>
            <td>
              <div className={styles.totalCopy}>{t("portfolio.totale")}</div>
            </td>
            <td className={styles.tableLine}>
              <span className={styles.totalCopy}>{total1}</span>
            </td>
            <td className={styles.tableNoLine}>
              <span className={styles.totalCopy}>{total2}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default FinecoTableCompare;
